import React from "react"
import FooterList from "./FooterList"

const Footer = () => {
  return (
    <footer className="footer">
      <FooterList />

      <div className="footer-bottom">
        <div className="footer-lang-container">
          <img
            className="footer-flag"
            src="/images/Footer/English.svg"
            alt="Language"
          />
          <span className="footer-language">English</span>
        </div>
        {/* Automatically update year */}
        <span className="footer-year">&copy; {new Date().getFullYear()}</span>
      </div>
    </footer>
  )
}

export default Footer
